module.exports = __webpack_public_path__ + "80c9ed65ec028607de3ff1d0979f8018.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/collection-gray.png
 ** module id = 1398
 ** module chunks = 0
 **/